import React, { useState, useEffect } from 'react';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const projects = [
    {
      id: 1,
      title: 'Food Finds',
      image: '/food-finds.jpg',
      category: ['All', 'Web'],
      link: 'https://drive.google.com/file/d/1lN7W6xxcNnfL7MWjFwMrDHinJ2ad53lS/view?usp=sharing'
    },
    {
      id: 2,
      title: 'Burrito Boy',
      image: '/burrito-boy.jpg',
      category: ['All', 'Mobile'],
      link: 'https://drive.google.com/file/d/1Cf6xsFlYw3n2bnE7j8WVUJIC2Lq_cp6c/view?usp=sharing'
    },
    {
      id: 3,
      title: 'Trail Isolation',
      image: '/trail-isolation.jpg',
      category: ['All', 'AI/ML'],
      link: 'https://drive.google.com/file/d/1dMGn4KeVjXRhrVXn_9eYoVOKjKMcHJLP/view?usp=sharing'
    },
    {
      id: 4,
      title: 'Multivariate Gaussian Mixture Modeling',
      image: '/gmm.jpg',
      category: ['All', 'AI/ML'],
      link: 'https://drive.google.com/file/d/1CFGQv4D8AeIg2W7XjN_J7z4IvGMeZbwm/view?usp=sharing'
    },
  ];


  const filters = ['All', 'Web', 'Mobile', 'AI/ML'];

  const filteredProjects = projects.filter(project => 
    project.category.includes(activeFilter)
  );


  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      padding: '4rem 1rem',
      fontFamily: 'Arial, sans-serif',
      overflowX: 'hidden'
    },
    title: {
      fontSize: isMobile ? '2.5rem' : '3.5rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '3rem',
      letterSpacing: '0.05em',
      padding: '0'
    },
    filterContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem',
      marginBottom: '4rem',
      flexWrap: 'wrap'
    },
    filterButton: {
      padding: '0.75rem 1.5rem',
      fontSize: '1.125rem',
      backgroundColor: 'transparent',
      color: '#ffffff',
      border: '2px solid #ffffff',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontWeight: '500'
    },
    filterButtonActive: {
      backgroundColor: '#ffffff',
      color: '#2a2e35'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(350px, 100%), 1fr))',
      gap: '2rem',
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0'
    },
    card: {
      position: 'relative',
      borderRadius: '12px',
      overflow: 'hidden',
      cursor: 'pointer',
      height: '280px',
      transition: 'transform 0.3s ease',
      backgroundColor: '#1a1a1a'
    },
    cardHover: {
      transform: 'translateY(-8px)'
    },
    cardImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    cardOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0,
      transition: 'opacity 0.3s ease'
    },
    cardOverlayHover: {
      opacity: 1
    },
    cardTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#ffffff',
      textAlign: 'center'
    }
  };


  return (
    <div style={styles.container} id="portfolio">
      <h1 style={styles.title}>PORTFOLIO</h1>
      
      <div style={styles.filterContainer}>
        {filters.map(filter => (
          <button
            key={filter}
            style={{
              ...styles.filterButton,
              ...(activeFilter === filter ? styles.filterButtonActive : {})
            }}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      <div style={styles.grid}>
        {filteredProjects.map(project => (
          <a
            key={project.id}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...styles.card,
              ...(hoveredCard === project.id ? styles.cardHover : {})
            }}
            onMouseEnter={() => setHoveredCard(project.id)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <img 
              src={project.image} 
              alt={project.title}
              style={styles.cardImage}
            />
            <div 
              style={{
                ...styles.cardOverlay,
                ...(hoveredCard === project.id ? styles.cardOverlayHover : {})
              }}
            >
              <h3 style={styles.cardTitle}>{project.title}</h3>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
